import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {RestApiService} from '../../../../core/services/http/rest-api.service';
import {ApiCreateEditHealthCenterRequest} from './api-create-edit-health-center-request';
import {Observable} from 'rxjs';
import {ApiCreateEditHealthCenterResponse} from './api-create-edit-health-center-response';
import {ApiRoutesEnum} from '../../../../core/services/http/api-routes.enum';
import {ApiHealthCentersListPaginatedQueryParams} from './api-health-centers-list-paginated-query-params';
import {ApiHealthCentersListResponse} from './api-health-centers-list-response';
import {ApiHealthCenterResponse} from './api-health-center-response';
import {ApiHealthCentersShortListItemResponse} from './api-health-centers-short-list-item-response';
/* eslint-disable max-len */
import {ApiGetHealthCenterSensorsOrdersListPaginatedResponse} from './api-get-health-center-sensors-orders-list-paginated-response';
import {ApiGetHealthCenterSensorsOrdersListPaginatedQueryParams} from './api-get-health-center-sensors-orders-list-paginated-query-params';
import {ApiUpdateSensorOrderShippedAtRequest} from './api-update-sensor-order-shipped-at-request';

/* eslint-enable max-len */

@Injectable()
export class HealthCenterRestApiService {

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _restApiService: RestApiService,
  ) {
  }

  public requestHealthCenter(healthCenterId: string): Observable<ApiHealthCenterResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.HEALTH_CENTERS,
      healthCenterId,
    ].join('/');
    return this._httpClient.get<ApiHealthCenterResponse>(url);
  }

  public requestCreate(data: ApiCreateEditHealthCenterRequest): Observable<ApiCreateEditHealthCenterResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.HEALTH_CENTERS,
    ].join('/');
    return this._httpClient.post<ApiCreateEditHealthCenterResponse>(url, data);
  }

  public requestUpdate(healthCenterId: string, data: ApiCreateEditHealthCenterRequest): Observable<void> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.HEALTH_CENTERS,
      healthCenterId,
    ].join('/');
    return this._httpClient.put<void>(url, data);
  }

  public requestHealthCenterListPaginated(
    queryParams: ApiHealthCentersListPaginatedQueryParams,
  ): Observable<ApiHealthCentersListResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.HEALTH_CENTERS,
    ].join('/');
    const params: HttpParams = this._restApiService.createHttpParams(queryParams);
    return this._httpClient.get<ApiHealthCentersListResponse>(url, {params: params});
  }

  public requestHealthCenterShortListOfName(): Observable<Array<ApiHealthCentersShortListItemResponse>> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.HEALTH_CENTERS,
      ApiRoutesEnum.HEALTH_CENTERS_SHORT_LIST_BY_NAME,
    ].join('/');
    return this._httpClient.get<Array<ApiHealthCentersShortListItemResponse>>(url);
  }

  public requestSensorOrders(
    healthCenterId: string,
    queryParams: ApiGetHealthCenterSensorsOrdersListPaginatedQueryParams,
  ): Observable<ApiGetHealthCenterSensorsOrdersListPaginatedResponse> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.HEALTH_CENTERS_ORDERS.replace(':id', healthCenterId),
    ].join('/');
    const params: HttpParams = this._restApiService.createHttpParams(queryParams);
    return this._httpClient.get<ApiGetHealthCenterSensorsOrdersListPaginatedResponse>(url, {params: params});
  }

  public requestSensorsOrderShipping(
    orderId: string,
    shippedAt: string,
  ): Observable<void> {
    const url: string = [
      this._restApiService.apiUrl,
      ApiRoutesEnum.SENSORS_ORDERS,
      orderId,
    ].join('/');
    const data: ApiUpdateSensorOrderShippedAtRequest = {shippedAt: shippedAt};
    return this._httpClient.put<void>(url, data);
  }
}
